import { render } from "./PrimaryButton.vue?vue&type=template&id=7f687f02&scoped=true&ts=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"

import "./PrimaryButton.vue?vue&type=style&index=0&id=7f687f02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f687f02"]])

export default __exports__